import { alpha, type Theme } from "@mui/material/styles";
import type { AppSx } from "../types";

export interface WidgetOutputViewComponentStyles {
  content: AppSx;
  tileRoot: AppSx;
  loadingOverlay: AppSx;
  titleBar: AppSx;
  titleText: AppSx;
  contentBox: AppSx;
  contentBoxWithTitle: AppSx;
  emptyContent: AppSx;
  warningsAlert: AppSx;
}

export function buildWidgetOutputViewComponentStyles(theme: Theme): WidgetOutputViewComponentStyles {
  const content: AppSx = {
    flex: 1,
    minHeight: 0,
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
  };

  return {
    content,
    tileRoot: {
      height: "100%",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      borderRadius: 2,
      border: "1px solid",
      borderColor: "divider",
      bgcolor: "background.paper",
      boxShadow:
        theme.palette.mode === "dark"
          ? "none"
          : "0 1px 3px rgba(15,23,42,0.08), 0 1px 2px rgba(15,23,42,0.04)",
      position: "relative",
    },
    loadingOverlay: {
      position: "absolute",
      inset: 0,
      bgcolor: alpha(theme.palette.background.paper, 0.72),
      zIndex: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    titleBar: {
      px: 1.5,
      py: 1,
      flexShrink: 0,
      borderBottom: "1px solid",
      borderColor: "divider",
      bgcolor: alpha(
        theme.palette.primary.main,
        theme.palette.mode === "dark" ? 0.1 : 0.04
      ),
    },
    titleText: {
      pr: 4,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      letterSpacing: 0.1,
    },
    contentBox: { ...content, p: 1.5 },
    contentBoxWithTitle: { ...content, p: 1.5 },
    emptyContent: {
      ...content,
      alignItems: "center",
      justifyContent: "center",
      flex: 1,
    },
    warningsAlert: { mb: 1.5, flexShrink: 0 },
  };
}
